import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    Link,
    TextField,
    Typography,

} from '@mui/material';
import {
    createState,
    Downgraded,
    useState,
} from '@hookstate/core';
import { withRouter, useHistory } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import validator from 'validator';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import * as forge from 'node-forge';
import Logo from '../../assets/images/logo.png';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import RouteConstants from '../../constants/routeConstants';
import { loginRequest } from '../../config/authConfig';

const userState = createState({
    email: '',
    password: '',
});
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const helperRoot = {
    margin: 0,
};

const Login = (props) => {
    const history = useHistory();
    const { instance, inProgress } = useMsal();
    const state = useState(userState);
    const loading = useState(false);
    const [emailErr, setEmailErr] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };

    const isEmailExist = () => {
        const email = state.email.get().trim();
        const flag = email != '' ? validateEmail(email) : true;
        const emlErr = flag ? '' : 'Please enter valid Email';
        setEmailErr(emlErr);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        loading.set(true);
        // if (loginType == 'janrain') {
        let req = { ...state.attach(Downgraded).get() };
        // eslint-disable-next-line no-undef
        const publicKey = process.env.REACT_APP_PUBLIC_KEY;

        var rsa = forge.pki.publicKeyFromPem(publicKey);
        var encryptedPassword = window.btoa(rsa.encrypt(req.password));
        let encryptedEmail = window.btoa(rsa.encrypt(req.email.toLowerCase()));
        req = {
            email: encryptedEmail,
            password: encryptedPassword,
        };

        //req.email = req.email.toLowerCase();
        ApiHelper.post(APIURLConstants.POST_VALIDATE_USER, req)
            .then((res) => {
                if (res.data.status === 200) {
                    Helper.setStorage('chk', 'jr');
                    const user = JSON.parse(res.data.response);
                    if (user.email && user.token) {
                        Helper.setStorage('accessToken', user.token);
                        // getDetails();
                        loading.set(false);
                        props.setLogin(false);
                    }
                } else {
                    loading.set(false);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: res.data.message,
                    });
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Your email or password was invalid';
                }
                snackBarProps.openSnack = true;
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                loading.set(false);
                props.setLogin(false);
            });
        // }
    };

    const handleLogin = () => {
        instance
            .handleRedirectPromise()
            .then(async (tokenResponse) => {
                if (!tokenResponse) {
                    const accounts = instance.getAllAccounts();
                    if (accounts.length === 0) {
                        // No user signed in
                        let check = await instance.loginRedirect(loginRequest);
                        if (check.accessToken) {
                            Helper.setStorage('accessToken', check.accessToken);
                            Helper.setStorage('chk', 'aad');
                            props.setShowLogin(false);
                        }
                    }
                    else {
                        if (instance && accounts[0]) {
                            const accessTokenRequest = {
                                ...loginRequest,
                                account: accounts[0],
                            };
                            if (inProgress === InteractionStatus.None) {
                                // eslint-disable-next-line no-debugger
                                // debugger
                                instance
                                    .acquireTokenSilent(accessTokenRequest)
                                    .then(async (response) => {
                                        Helper.setStorage("accessToken", response.accessToken);
                                        Helper.setStorage("chk", "aad");
                                        window.location.reload();
                                    })
                                    .catch((error) => {
                                        console.log('login page - inside catch token error');
                                        if (error instanceof InteractionRequiredAuthError) {
                                            console.log('login page - inside this token error redirect call');
                                            instance.acquireTokenRedirect(accessTokenRequest);
                                        }
                                    });
                            }
                        }
                        console.log(accounts);
                    }
                } else {
                    // Do something with the tokenResponse
                    Helper.setStorage('chk', 'aad');
                    props.setShowLogin(false);
                }
            })
            .catch((err) => {
                // Handle error
                console.error(err);
            });
        // eslint-disable-next-line no-debugger
        // debugger
        // location.href = "/sso";
        //props.history.replace("/sso");
    };

    const onForgotPassword = () => {

        // // eslint-disable-next-line no-debugger
        // debugger
        history.push({
            pathname: RouteConstants.FORGOT_PASSWORD,
        });
    }

    return (
        <Box sx={{ width: '100%', height: '100vh' }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Box
                        sx={{
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}>
                        <Box className="loginBox">
                            <Box className="loginHeader">
                                <Box
                                    component="img"
                                    alt="logo."
                                    src={Logo}
                                    sx={{ height: 42 }}
                                />
                            </Box>
                            <Box className="loginContentBox">
                                <Box
                                    component="form"
                                    autoComplete="off"
                                    onSubmit={handleSubmit}>
                                    <Box className="textContent">
                                        <TextField
                                            required
                                            size="small"
                                            label="Email"
                                            autoComplete="off"
                                            value={state.email.get()}
                                            onChange={(event) => {
                                                let str = event.target.value;
                                                str = str.replace(/^\s+/g, '');
                                                state.email.set(str);
                                            }}
                                            onBlur={() => isEmailExist()}
                                            helperText={emailErr}
                                            error={
                                                emailErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            inputProps={{ maxLength: 100 }}
                                            sx={{ width: '100%' }}
                                            FormHelperTextProps={{
                                                classes: {
                                                    root: helperRoot,
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box className="textContent">
                                        <TextField
                                            required
                                            type="password"
                                            size="small"
                                            label="Password"
                                            autoComplete="off"
                                            value={state.password.get()}
                                            onChange={(event) => {
                                                state.password.set(
                                                    event.target.value
                                                );
                                            }}
                                            inputProps={{ maxLength: 30 }}
                                            sx={{ width: '100%' }}
                                        />
                                    </Box>
                                    <Box className="textContent">
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            sx={{ width: '100%' }}>
                                            Login
                                        </Button>
                                    </Box>
                                </Box>

                                <Box className="textContent" sx={{ m: 0 }}>
                                    <Typography variant="h6" fontSize={14}>
                                        If you have NBA Account, sign in using
                                        SSO
                                    </Typography>
                                </Box>
                                <Box className="textContent">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{ width: '100%' }}
                                        onClick={() => handleLogin()}>
                                        SSO
                                    </Button>
                                </Box>
                                <Box className="bottomContent">
                                    <span>
                                        <Link onClick={onForgotPassword} sx={{ cursor: 'pointer' }}>Forgot Password</Link>
                                    </span>
                                    <span>
                                        <Checkbox />
                                        Remember Me
                                    </span>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default withRouter(Login);
